import styled from "styled-components";

export const CompanyListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
  height: 100%;
  margin-top: 22px;
  gap: 12px;
`;
